<template lang="pug">
.pendings-container.pointer(v-if="show" @click="close")
  .pendings-container-content.relative(@click.stop="")
    .times-icon.pointer(@click="close")
    .pendings-title
      span {{ 'Talla ' }}
      span.uppercase
        span {{ size }}
        span {{ ' ' }}
        span.tag {{ product.pendingOrders[indexSize].length }}

    .pendings-product-container
      .pending-product-container(v-for="(order, index) in pendingOrders")
        span.pending-product.relative.clickable(@click="openOrderOrChange(order)") {{ order }}
</template>

<script>
export default {
  name: 'pendings',

  props: {
    show: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: true
    }
  },

  computed: {
    indexSize () {
      return this.product.sizes.findIndex(size => size === this.size)
    },
    pendingOrders () {
      if (this.indexSize === -1) return []
      return this.product.pendingOrders[this.indexSize]
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    deletepending (indexpending) {
      this.product.pendings[this.indexSize].splice(indexpending, 1)
      this.$emit('updatependings', {
        action: 'delete',
        indexSize: this.indexSize,
        indexpending
      })
    },

    addpending (pending) {
      this.product.pendings[this.indexSize].push(pending)
      this.$emit('updatependings', {
        action: 'add',
        indexSize: this.indexSize,
        pending
      })
    },

    enablepending (enable) {
      this.$set(this.product.showLast, this.indexSize, enable)
    },

    openOrderOrChange (orderCode) {
      const firstChar = orderCode.charAt(0).toLowerCase()
      
      if (firstChar === 'c') {
        const changeWithoutC = orderCode.substring(1)
        const routeData = this.$router.resolve({
          path: '/changes',
          query: { change: changeWithoutC }
        })
        window.open(routeData.href, '_blank')
      } else if (firstChar === 's') {
        const routeData = this.$router.resolve({
          path: '/orders',
          query: { Order: orderCode.toLowerCase() }
        })
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.pendings-container
  position fixed
  top 0
  left 0
  width 100vw
  height 100vh
  background-color rgba(0, 0, 0, 0.5)
  z-index 1000
  display flex
  justify-content center
  align-items center
  z-index 100

.pendings-container-content
  background-color var(--background-principal)
  padding 3em 4rem
  border-radius 1em
  width 100%
  max-width 50rem
  cursor default

.pendings-product-container
  display flex
  align-items center
  gap 2rem
  flex-wrap wrap

.pendings-title
  font-size 1.2em
  font-weight 600
  margin-bottom 2em
  text-align left

.times-icon
  position absolute
  top 1rem
  right 1.5rem
  cursor pointer

.pending-product
  font-size 1.2rem

.clickable
  cursor pointer
  text-decoration underline
  color var(--color-primary)

.clickable:hover
  opacity 0.7
</style>



// WEBPACK FOOTER //
// src/components/pages/product/Pending.vue